export default {"src":"/_next/static/media/ico-print.70c40aee.svg","height":35,"width":34,"blurWidth":0,"blurHeight":0};